import { Link, Navigate } from "react-router-dom";
import { GraduationCap, ShieldCheck } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { dashPathFor } from "../components/GoogleAuth";
import { DemoLogin } from "../components/DemoLogin";
import { OtpLogin } from "../components/OtpLogin";

export default function Login({ register = false }) {
  const { user, loading } = useAuth();
  if (loading) return <p data-testid="login-loading" className="p-10">Checking your session…</p>;
  if (user) return <Navigate to={dashPathFor(user)} replace />;
  return <div className="max-w-md mx-auto px-4 py-16"><div className="nb p-8" data-testid="otp-auth">
    <GraduationCap size={32} className="text-emerald-700 mb-5" />
    <h1 className="font-display text-3xl font-extrabold tracking-tight">{register ? "Join DreamCots" : "Welcome back"}</h1>
    <p className="text-slate-500 text-sm mt-3">Sign in with your email — we'll send a one-time code. One account for students, teachers and institutes.</p>
    <OtpLogin register={register} />
    <DemoLogin />
    <p className="text-xs text-slate-500 mt-5 flex gap-2"><ShieldCheck size={18} className="shrink-0" />No passwords to remember. New members choose their role and complete their details after verifying their email.</p>
    <p data-testid="existing-phone-guidance" className="text-xs text-slate-500 mt-4">Already registered a phone number? Sign in with the email connected to it. We won't create a duplicate account.</p>
    <Link to="/" data-testid="auth-browse-directory" className="block text-center text-sm text-emerald-700 mt-6">Continue browsing</Link>
  </div></div>;
}
